import React from 'react';

/**
 * Table header component for ProjectList, handling sorting and bulk selection.
 * 
 * @param {Object} props
 * @param {boolean} props.showBulk
 * @param {Object} props.globalPermissions
 * @param {Array} props.list - The list of projects currently displayed.
 * @param {Array} props.selectedProjectIds
 * @param {Function} props.setSelectedProjectIds
 * @param {Function} props.handleSort
 * @param {Object} props.sortConfig
 */
export default function ProjectTableHeader({
    showBulk,
    globalPermissions,
    list,
    selectedProjectIds,
    setSelectedProjectIds,
    handleSort,
    sortConfig
}) {
    const renderSortArrow = (key) => sortConfig.key === key ? (sortConfig.direction === 'asc' ? ' ↑' : ' ↓') : '';

    return (
        <thead>
            <tr>
                {showBulk && globalPermissions.delete_projects && (
                    <th style={{ width: '60px', textAlign: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    const listIds = list.map(p => p.id);
                                    if (e.target.checked) {
                                        setSelectedProjectIds(prev => [...new Set([...prev, ...listIds])]);
                                    } else {
                                        setSelectedProjectIds(prev => prev.filter(pid => !listIds.includes(pid)));
                                    }
                                }}
                                checked={list.length > 0 && list.every(p => selectedProjectIds.includes(p.id))}
                            />
                        </div>
                    </th>
                )}
                <th onClick={() => handleSort('status')} className="sortable-header align-center">
                    <div className="header-inner">
                        <span className="header-text">Status</span>
                        <span className="sort-indicator">{renderSortArrow('status')}</span>
                    </div>
                </th>
                <th onClick={() => handleSort('project_number')} className="sortable-header">
                    <div className="header-inner">
                        <span className="header-text">Nr.</span>
                        <span className="sort-indicator">{renderSortArrow('project_number')}</span>
                    </div>
                </th>
                <th onClick={() => handleSort('name')} className="sortable-header">
                    <div className="header-inner">
                        <span className="header-text">Name</span>
                        <span className="sort-indicator">{renderSortArrow('name')}</span>
                    </div>
                </th>
                <th onClick={() => handleSort('address')} className="sortable-header">
                    <div className="header-inner">
                        <span className="header-text">Standort</span>
                        <span className="sort-indicator">{renderSortArrow('address')}</span>
                    </div>
                </th>
                <th className="header-actions align-center">
                    <div className="header-inner">
                        <span className="header-text">Aktionen</span>
                    </div>
                </th>
            </tr>
        </thead>
    );
}
